export const PERMISSION_CONSTANTS = {
  INVOICE_RESUBMIT_PERMISSION: 'RESUBMIT_INVOICE',
  ADVANCE_PAYMENT_UPDATE: 'EDIT_ADVANCE_PAYMENTS',
  UPDATE_CLIENT_TYPE_FIELD: 'UPDATE_CLIENT_TYPE',
  UPDATE_CLIENT_ORACLE_DATA: 'UPDATE_CLIENT_ORACLE_DATA',
  UPDATE_AIRCRAFT_COST_CENTER: 'UPDATE_AIRCRAFT_COST_CENTER',
  DELETE_ADVANCE_PAYMENTS: 'DELETE_ADVANCE_PAYMENTS',
  DELETE_PAYMENT_FE: 'DELETE_PAYMENT_FE',
  UPDATE_PAYMENT_FE: 'UPDATE_PAYMENT_FE',
  RETRY_ORACLE_EBS_INVOICE_UPLOAD: 'RETRY_ORACLE_EBS_INVOICE_UPLOAD',
  VIEW_EBS_DISTRIBUTION: 'VIEW_EBS_DISTRIBUTION',
  CREATE_DEBIT_NOTE: 'CREATE_DEBIT_NOTE',
  INVOICE_MARK_AS_MANUAL_EBS: 'INVOICE_MARK_AS_MANUAL_EBS',
  DELETE_QUOTATION: 'DELETE_QUOTATION',
  CHARTER_CONTRACTS_VIEW_FE: 'CHARTER_CONTRACTS_VIEW_FE',
  CREATE_CHARTER_CONTRACT: 'CREATE_CHARTER_CONTRACT',
  LIST_CHARTER_CONTRACTS: 'LIST_CHARTER_CONTRACTS',
  FETCH_CHARTER_CONTRACT: 'FETCH_CHARTER_CONTRACT',
  UPDATE_CHARTER_CONTRACT: 'UPDATE_CHARTER_CONTRACT',
  DELETE_CHARTER_CONTRACT: 'DELETE_CHARTER_CONTRACT',
  CREATE_MEAL_CATEGORY: 'CREATE_MEAL_CATEGORY',
  LIST_MEAL_CATEGORY: 'LIST_MEAL_CATEGORY',
  FETCH_MEAL_CATEGORY: 'FETCH_MEAL_CATEGORY',
  UPDATE_MEAL_CATEGORY: 'UPDATE_MEAL_CATEGORY',
  DELETE_MEAL_CATEGORY: 'DELETE_MEAL_CATEGORY',
  CREATE_INTERNET_PACKAGE: 'CREATE_INTERNET_PACKAGE',
  LIST_INTERNET_PACKAGE: 'LIST_INTERNET_PACKAGE',
  FETCH_INTERNET_PACKAGE: 'FETCH_INTERNET_PACKAGE',
  UPDATE_INTERNET_PACKAGE: 'UPDATE_INTERNET_PACKAGE',
  DELETE_INTERNET_PACKAGE: 'DELETE_INTERNET_PACKAGE',
  CREATE_LAYOVER_CATEGORY: 'CREATE_LAYOVER_CATEGORY',
  LIST_LAYOVER_CATEGORY: 'LIST_LAYOVER_CATEGORY',
  FETCH_LAYOVER_CATEGORY: 'FETCH_LAYOVER_CATEGORY',
  UPDATE_LAYOVER_CATEGORY: 'UPDATE_LAYOVER_CATEGORY',
  DELETE_LAYOVER_CATEGORY: 'DELETE_LAYOVER_CATEGORY',
  CREATE_WAITING_CATEGORY: 'CREATE_WAITING_CATEGORY',
  LIST_WAITING_CATEGORY: 'LIST_WAITING_CATEGORY',
  FETCH_WAITING_CATEGORY: 'FETCH_WAITING_CATEGORY',
  UPDATE_WAITING_CATEGORY: 'UPDATE_WAITING_CATEGORY',
  DELETE_WAITING_CATEGORY: 'DELETE_WAITING_CATEGORY',
  EDIT_FINANCE_CREDIT_NOTE_VAT: 'EDIT_FINANCE_CREDIT_NOTE_VAT',
};
